
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { MatDialog, MatDialogConfig, MatDialogRef, MatDialogState } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { ConfirmDialogConfig, SessionConfirmComponent } from './session-confirm.component';

@Injectable({
  providedIn: 'root'
})
export class SessionConfirmService {

  private dialogRef!: MatDialogRef<SessionConfirmComponent, null>;

  constructor(private srvDialog: MatDialog, private translate: TranslateService) { }

  private readonly setDialogConfig = (data: ConfirmDialogConfig) => {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = data;
    dialogConfig.maxWidth = 600;
    dialogConfig.width = '98%';
    dialogConfig.height = 'auto';
    dialogConfig.panelClass = 'custom-dialog-confirm-messages';
    dialogConfig.disableClose = true;
    dialogConfig.hasBackdrop = true;
    return dialogConfig;
  };

  public showDialog(config: ConfirmDialogConfig): Observable<null | undefined> {
    // Close the previous dialog if exist
    if ((this.dialogRef) && (this.dialogRef.getState() == MatDialogState.OPEN)) {
      this.dialogRef.close();
    }

    this.dialogRef = this.srvDialog.open(SessionConfirmComponent, this.setDialogConfig(config))

    return this.dialogRef.afterClosed();
  }

  public isDialogOpen(): boolean {
    return ((this.dialogRef) && (this.dialogRef.getState() == MatDialogState.OPEN));
  }


}